<template>
  <div class="set-availability">
    <el-form :model="availabilityForm" label-width="120px">
      <!-- <el-form-item label="教练编号">
        <el-input v-model="availabilityForm.jiaolianbianhao" placeholder="请输入教练编号"></el-input>
      </el-form-item> -->
      <el-form-item label="开始时间">
        <el-date-picker
          v-model="availabilityForm.availableFrom"
          type="datetime"
          placeholder="选择开始时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker
          v-model="availabilityForm.availableUntil"
          type="datetime"
          placeholder="选择结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="setAvailability">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { ElMessage } from "element-ui";
export default {
  data() {
    return {
      availabilityForm: {
        jiaolianbianhao: "",
        availableFrom: "",
        availableUntil: ""
      }
    };
  },
  methods: {
    formatDate(date) {
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:00`;
    },
    setAvailability() {
      const coachId = localStorage.getItem('adminName').replace(/"/g, ''); 

      // const coachId = localStorage.getItem('adminName'); // 获取当前登录教练编号
      if (!coachId) {
        this.$message.error('无法获取登录信息');
        return;
      }

    console.log("this.$route.params.jiaolianbianhao", this.$route.params.jiaolianbianhao);
        console.log("localStorage.getItem('adminName')", localStorage.getItem('adminName'));

            console.log("coachId", coachId);


    const { availableFrom, availableUntil } = this.availabilityForm;
    // 构建查询字符串
    const queryString = `?jiaolianbianhao=${encodeURIComponent(coachId)}&availableFrom=${this.formatDate(availableFrom)}&availableUntil=${this.formatDate(availableUntil)}`;
    //  const queryString = `?id=${encodeURIComponent(this.form.id)}&availableFrom=${this.formatDate(this.form.availableFrom)}&availableUntil=${this.formatDate(this.form.availableUntil)}`;


    this.$http.post(`/schedule/setAvailability${queryString}`)
      .then(({ data }) => {
        if (data && data.code === 0) {
          this.$message.success("空闲时间设置成功");
        } else {
          this.$message.error(data.msg || "设置失败");
        }
      })
      .catch((error) => {
        this.$message.error("请求失败，请重试");
        console.error(error);
      });
  }
  }
};
</script>

<style scoped>
.set-availability {
  max-width: 400px;
  margin: 0 auto;
}
</style>
